import { render, staticRenderFns } from "./MainNav.vue?vue&type=template&id=2ffaa457&"
import script from "./MainNav.vue?vue&type=script&lang=js&"
export * from "./MainNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports